import Await from "../../components/async/Await";
import NavigatorView from "../../navigation/NavigatorView";
import RouteSwitch from "../../navigation/RouteSwitch";
import RouteView from "../../navigation/RouteView";
import CandidatePage from "./CandidatePage";
import ContactPage from "./ContactPage";
import ContactsPage from "./ContactsPage";
import InviteMemberPage from "./InviteMemberPage";
import {
    candidateRoute,
    contactRoute,
    contactsNavigator,
    contactsRoute,
    invitationRoute,
    newContactsRoute,
} from "./navigation";
import NewContactPage from "./NewContactPage";

export default function ContactsNavigator() {
    return (
        <NavigatorView navigator={contactsNavigator}>
            <Await>
                <RouteSwitch>
                    <RouteView route={contactsRoute} component={ContactsPage} />
                    <RouteView route={newContactsRoute} component={NewContactPage} />
                    <RouteView route={candidateRoute} component={CandidatePage} />
                    <RouteView route={invitationRoute} component={InviteMemberPage} />
                    <RouteView route={contactRoute} component={ContactPage} />
                </RouteSwitch>
            </Await>
        </NavigatorView>
    );
}
